import { render } from "./Home.vue?vue&type=template&id=754e2c8e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=754e2c8e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1095094746/src/dapp.nftea.studio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754e2c8e"]])

export default __exports__